import { render, staticRenderFns } from "./ListFields.vue?vue&type=template&id=8009a850"
import script from "./ListFields.vue?vue&type=script&lang=js"
export * from "./ListFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListFields.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8009a850')) {
      api.createRecord('8009a850', component.options)
    } else {
      api.reload('8009a850', component.options)
    }
    module.hot.accept("./ListFields.vue?vue&type=template&id=8009a850", function () {
      api.rerender('8009a850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/ListFields.vue"
export default component.exports